var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "chevron-up_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.056 44c11.677-5.282 20.119-9.824 23.865-15.92 0 0 0 .014.014.028v-.029c3.683 6.03 12.002 10.5 23.517 15.665l-23.57-23.57z"
  })));
};
export { SvgChevronUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNy4wNTU5MSA0NEMxOC43MzMgMzguNzE4MyAyNy4xNzUgMzQuMTc2NCAzMC45MjExIDI4LjA3OTRDMzAuOTIxMSAyOC4wNzk0IDMwLjkyMTEgMjguMDkzNSAzMC45MzUzIDI4LjEwNzhMMzAuOTM1NCAyOC4wNzk1QzM0LjYxODEgMzQuMTA5NyA0Mi45MzczIDM4LjU3OTkgNTQuNDUxNyA0My43NDM4TDMwLjg4MTkgMjAuMTc0MUw3LjA1NTkxIDQ0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";